import { render, staticRenderFns } from "./Illegal_building.vue?vue&type=template&id=4df0edb4"
import script from "./Illegal_building.vue?vue&type=script&lang=js"
export * from "./Illegal_building.vue?vue&type=script&lang=js"
import style0 from "./Illegal_building.vue?vue&type=style&index=0&id=4df0edb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports